import { CALENDAR_GRID_LABEL_SEPARATOR } from '../../../../constants/calendarGrid'
import { getCalendarGridItemCardDayLabel } from '../../CalendarGrid.utils'
import { getCalendarGridItemTimeLabel } from '../../CalendarGrid.utils.time'

export function getCalendarGridItemCardHeaderText({
  item,
  locale,
  t,
  timezone,
}) {
  const kindLabel = item.popover?.kindLabel

  const dateParts = [
    getCalendarGridItemCardDayLabel({ item, locale, timezone }),
    getCalendarGridItemTimeLabel({ item, locale, t, timezone }),
  ]

  return (kindLabel ? [kindLabel, ...dateParts] : dateParts).join(
    CALENDAR_GRID_LABEL_SEPARATOR
  )
}
